import React from 'react';
import {motion} from 'framer-motion';
import {PROTOCOLS} from '../utils/data';

export const ProtocolSelector=({selectedId,onSelect})=> {
  return (
    <div className="grid grid-cols-2 gap-4 w-full max-w-md">
      {PROTOCOLS.map((p)=> {
        const isSelected=selectedId===p.id;
        return (
          <motion.button
            key={p.id}
            whileTap={{scale: 0.98}}
            onClick={()=> onSelect(p.id)}
            className={`
              relative p-5 rounded-[2rem] border text-left transition-all duration-300
              ${isSelected 
                ? 'bg-slate-900 border-slate-900 shadow-xl shadow-slate-200' 
                : 'bg-white border-slate-100 hover:border-slate-300'}
            `}
          >
            <div className={`text-2xl font-black mb-1 ${isSelected ? 'text-white' : 'text-slate-900'}`}>
              {p.label}
            </div>
            <div className={`text-[10px] font-black uppercase tracking-widest mb-2 ${isSelected ? 'text-emerald-400' : p.color}`}>
              {p.difficulty}
            </div>
            <div className={`text-[11px] leading-snug font-medium ${isSelected ? 'text-slate-400' : 'text-slate-500'}`}>
              {p.description}
            </div>
            {isSelected && (
              <motion.div
                layoutId="active-indicator"
                className="absolute top-4 right-4 w-1.5 h-1.5 rounded-full bg-emerald-400"
              />
            )}
          </motion.button>
        );
      })}
    </div>
  );
};